module.exports = __webpack_public_path__ + "img/sczc.6cef0215.jpg";